/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCreditDto } from '../../models/backend-actual-credit-dto';
import { BackendPatchedActualCreditRequestDto } from '../../models/backend-patched-actual-credit-request-dto';

export interface MonitoringActualsCreditsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedActualCreditRequestDto;
}

export function monitoringActualsCreditsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCreditsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCreditDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCreditsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCreditDto>;
    }),
  );
}

monitoringActualsCreditsPartialUpdate.PATH = '/api/monitoring/actuals/credits/{id}/';
